import { useMutation, useQueryClient } from 'react-query'
import { QUERY_KEYS } from 'src/constants'

import { accountsService } from 'src/services/accounts.service'
import { IUpdateAccountSubcriptionPricesDto } from 'src/types'

export const useUpdateAccountSupbscriptionPrices = (accountId: string) => {
  const queryClient = useQueryClient()

  return useMutation(
    (dto: IUpdateAccountSubcriptionPricesDto) =>
      accountsService.updateAccountPrices(accountId, dto),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries([
          QUERY_KEYS.ACCOUNT_DEFAULT_SUBSCRIPTION_PRICES,
          accountId,
        ])
      },
    },
  )
}
